import { Link } from "types/asset";

export const signupNavLink: Link[] = [{ url: "/log-out", text: "Log out" }];
